import { Text } from '../text';
import { Box } from '../Box';

export const Group = ({ children }) => {
  return (
    <Box
      css={`
        break-inside: avoid;
        min-height: 64px;
        width: 100%;
        border-radius: 8px;
        border: 1px solid var(--button-background-color);
        overflow: clip;
        margin-bottom: 16px;
        transition: transform 0.3s ease, opacity 0.3s ease;
      `}
      className="masonry-group"
    >
      {children}
    </Box>
  );
};

Group.Title = ({ value }) => (
  <Box
    className="masonry-group-title"
    css={`
      background-color: var(--button-background-color);
      padding: 8px;
    `}
  >
    <Text
      h4
      css={`
        color: var(--button-text-color);
      `}
    >
      {value}
    </Text>
  </Box>
);

Group.Content = ({ children }) => (
  <Box
    className="masonry-group-content"
    css={`
      padding: 16px;
    `}
  >
    {children}
  </Box>
);

Group.Item = ({ css: cssString = '', flex = 'space-between', children }) => (
  <Box
    className="masonry-group-item"
    flex={flex}
    css={`
      padding: 4px 0;
      ${cssString}
    `}
  >
    {children}
  </Box>
);
